import { render } from "./BlockUI.vue?vue&type=template&id=0c758f16&scoped=true&ts=true"
import script from "./BlockUI.vue?vue&type=script&lang=ts"
export * from "./BlockUI.vue?vue&type=script&lang=ts"

import "./BlockUI.vue?vue&type=style&index=0&id=0c758f16&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c758f16"]])

export default __exports__